export default () => ({
  btnText: {
    flexGrow: 1
  }
});
